import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { CheckDefaultPatientClinicProviderExistsResponse } from '../models/patient-clinic-provider';

@Injectable({
  providedIn: 'root'
})
export class PatientClinicProviderDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  checkPatientClinicProviderExists(patientId: number, providerId: number, clinicId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { patientId, clinicId, providerId, id };
    return this.httpClient.getJsonAsync<boolean>('patientClinicProvider/checkDuplicatePatientClinicProviderExists', data, timeout, false);
  }

  checkDefaultPatientClinicProviderExists(patientId: number, id: number): Promise<CheckDefaultPatientClinicProviderExistsResponse> {
    const data = { patientId, id };
    return this.httpClient.getJsonAsync<CheckDefaultPatientClinicProviderExistsResponse>('patientClinicProvider/checkDefaultPatientClinicProviderExists', data, null, false);
  }

  deletePatientClinicProviderAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('patientClinicProvider/delete', id, timeout);
  }
}
